import script from "./FrotaDash2.vue?vue&type=script&setup=true&lang=js"
export * from "./FrotaDash2.vue?vue&type=script&setup=true&lang=js"

import "./FrotaDash2.vue?vue&type=style&index=0&id=31086bb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31086bb6"]])

export default __exports__